import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-print-body",
  templateUrl: "./print-body.component.html",
  styleUrls: ["./print-body.component.scss"],
})
export class PrintBodyComponent implements OnInit {
  searchStringText;
  entityResult;
  pepResult;
  nslResult;
  sanctionResult;
  typeOfSearch = localStorage.getItem("searchType");
  searchedName = localStorage.getItem("searchedName");
  isAllDBSearch =
    localStorage.getItem("isAllDBSearch") == "true" ? true : false;
  isPepSearch = localStorage.getItem("isPepSearch") == "true" ? true : false;
  isHongKongSearch =
    localStorage.getItem("isHongKongSearch") == "true" ? true : false;
  isInternationalSearch =
    localStorage.getItem("isInternationalSearch") == "true" ? true : false;
  isIndividualSearch =
    localStorage.getItem("isIndividualSearch") == "true" ? true : false;
  isChineseSearch =
    localStorage.getItem("isChineseSearch") == "true" ? true : false;

  constructor(private route: ActivatedRoute) {
    if (this.isIndividualSearch) {
      this.pepResult = JSON.parse(localStorage.getItem("pepSearchResult"));
      this.nslResult = JSON.parse(localStorage.getItem("nslSearchResult"))[
        "found_records"
      ];
      this.sanctionResult = JSON.parse(
        localStorage.getItem("sanctionSearchResult")
      );
    } else {
      this.entityResult = JSON.parse(
        localStorage.getItem("entitySearchResult")
      );
    }
  }

  ngOnInit(): void {
    this.searchStringText =
      this.typeOfSearch != "advance"
        ? `QUICK SEARCH RESULTS FOR ${this.searchedName}`
        : `ADVANCE SEARCH RESULTS FOR ${this.searchedName}`;
  }
}
